import { Form, FormInstance, Modal, Upload, message } from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import CloudArrowUpImage from 'assets/images/CloudArrowUp.svg';
import { useEffect, useState } from 'react';
//fallback
import { PdfView } from 'presentation/components/pdf/pdfview';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { FILE_TYPE } from 'utilities/constants/COMMON';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { ENV } from '../../../../../infrastructure/config/CONSTANTS';

interface props {
    initialImageUrl?: string | undefined;
    form?: FormInstance;
    existedFile?: any;
    imageId?: number;
    initFile?: UploadFile[];
    setIsDisable?: (value: boolean) => void;
}
const STATUS = {
    UPLOADING: 'uploading',
    DONE: 'done',
    REMOVE: 'removed',
    UNDER_CONSTRUCTION: '施工中',
};

const getBase64Preview = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
const UploadImage = ({
    initialImageUrl,
    form,
    existedFile,
    imageId,
    initFile,
    setIsDisable,
}: props) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>();
    const [initialImg, setInitialImg] = useState<string>();
    const [imageIds, setImageIds] = useState<number>();
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileType, setFileType] = useState('');
    const dispatch = useAppDispatch();

    const fileTypes = ENV.FILE_TYPE_CU_043_01?.split(',');
    const maxFileSize = ENV.FILE_MAX_SIZE_CU_043_01;
    const maxFileCount = Number(ENV.FILE_MAX_NUMBER_CU_043_01);

    useEffect(() => {
        if (initialImageUrl) setInitialImg(initialImageUrl);
        if (existedFile && existedFile.file && existedFile.file.originFileObj)
            getBase64(existedFile.file.originFileObj as RcFile, (url) => {
                setImageUrl(url);
            });
    }, []);
    useEffect(() => {
        if (initFile) {
            setFileList(initFile);
            setIsDisable &&
                setIsDisable(
                    (!form?.getFieldValue('image') || !form.getFieldValue('image').file) &&
                        (!form?.getFieldValue('isEdit') ||
                            form?.getFieldValue('isEdit')?.length === 0),
                );
        }
    }, [initFile]);
    useEffect(() => {
        setInitialImg(initialImageUrl);
        setImageIds(imageId);
    }, [initialImageUrl]);

    const getBase64 = (img: RcFile, callback: (url: string) => void) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result as string));
        reader.readAsDataURL(img);
    };

    const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
        const invalidFileType = commonHelpers.validateFileTypes(file, fileTypes);
        if (invalidFileType) {
            message.error(getMessage('M007', invalidFileType));
        }
        const isValidFileSize = commonHelpers.validateFileSize(file, maxFileSize);
        if (!isValidFileSize) {
            message.error(getMessage('M006', maxFileSize + 'MB'));
        }

        //validate file list
        const isExceedMaxFileCount = FileList.length > maxFileCount;
        if (isExceedMaxFileCount) {
            message.error(getMessage('M010', maxFileCount));
        }

        return !invalidFileType && isValidFileSize && !isExceedMaxFileCount;
    };

    const dummyRequest = ({ file, onSuccess }: any) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

    const onChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        const isValidFileType = !commonHelpers.validateFileTypes(info.file, fileTypes);
        const isValidFileSize = commonHelpers.validateFileSize(info.file, maxFileSize);
        if ((isValidFileType && isValidFileSize) || info.file.status === STATUS.REMOVE) {
            setFileList(info.fileList);
        }
        if (info.file.status === STATUS.REMOVE) {
            const uids = form?.getFieldValue('isEdit') ? form?.getFieldValue('isEdit') : [];
            if (initFile?.filter((e) => e.uid === info.file.uid).length) {
                form?.setFieldValue('isEdit', [...uids, info.file.uid]);
            }
        }
        if (info.file.status === STATUS.UPLOADING) {
            setLoading(true);
            return;
        }
        if (setIsDisable) {
            setIsDisable(
                (!form?.getFieldValue('image') || !form.getFieldValue('image').file) &&
                    (!form?.getFieldValue('isEdit') || form?.getFieldValue('isEdit')?.length === 0),
            );
        }
    };

    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64Preview(file.originFileObj as RcFile);
        }
        if (file.name?.endsWith('.pdf')) {
            setFileType(FILE_TYPE.PDF);
        } else {
            setFileType(FILE_TYPE.IMAGE);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };
    const handleCancel = () => setPreviewOpen(false);
    const uploadButton = (
        <section
            style={{
                padding: '53px 26px',
                width: 343,
                border: '1px solid #D0D3D8',
                borderRadius: 4,
                background: '#ffffff',
            }}
        >
            <div className="center-inside" style={{ width: '100%' }}>
                <img alt="" src={CloudArrowUpImage} style={{ margin: 'auto' }} />
            </div>
            <div
                className="upload-title center-inside"
                style={{ marginTop: 12, color: '#192F51', fontSize: 14, fontWeight: 700 }}
            >
                ファイルをアップロード
            </div>
        </section>
    );
    const removeImage = () => {
        const confirmProps = commonHelpers.getConfirmProps('P013', {
            onOk: () => {
                const isEdit = fileList.map((item: any) => {
                    return item.uid;
                });
                form?.setFieldValue('isEdit', isEdit);
                setFileList([]);
                setIsDisable && setIsDisable(false);
            },
        });
        dispatch(showConfirm(confirmProps));
    };
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ marginBottom: 16 }} className="label">
                    一括返済計算書
                </div>
                {fileList.length <= 0 ? (
                    <></>
                ) : (
                    <div className="remove-button" onClick={removeImage}>
                        削除
                    </div>
                )}
            </div>
            <Form.Item name="image" style={{ margin: 0, padding: 0 }}>
                <Upload
                    className="upload-custom button-style"
                    name="avatar"
                    listType="picture"
                    showUploadList={true}
                    beforeUpload={beforeUpload}
                    onChange={onChange}
                    customRequest={dummyRequest}
                    onPreview={onPreview}
                    fileList={fileList}
                    defaultFileList={initFile}
                >
                    {fileList && fileList.length >= 10 ? null : uploadButton}
                </Upload>
            </Form.Item>
            <Modal
                open={previewOpen}
                footer={null}
                onCancel={handleCancel}
                width={800}
                style={{
                    maxHeight: 'calc(100vh - 110px)',
                    overflow: 'auto',
                    paddingBottom: 'unset',
                }}
            >
                {fileType == FILE_TYPE.IMAGE && (
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                )}
                {fileType == FILE_TYPE.PDF && (
                    <PdfView
                        source={previewImage}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                        width={760}
                    />
                )}
            </Modal>
        </>
    );
};

export default UploadImage;
